import { useDispatch } from 'react-redux';
import EditDialog from '../Common/EditDialog';
import useExistingClientGroupForm from '../../hooks/useExistingClientGroupForm ';
import { existingClientGroup } from '../../redux/actions/clientGroups';

function ExistingClientGroup({ setExistingClientGroup, id }) {
  const { existingClientGroupFormSchema } = useExistingClientGroupForm();

  const dispatch = useDispatch();

  const handleUpdate = (data: any) => {
    dispatch(existingClientGroup(data.GroupId, id));
  };
  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => setExistingClientGroup(false)}
      formSchema={existingClientGroupFormSchema}
    />
  );
}

export default ExistingClientGroup;
